import React from 'react';
import { returnSaneURL } from '../../../Utils/getImg';
import { TString } from '../Response/Utils';

interface Props {
	silent?: boolean;
	botImageCheck?: boolean;
	logoImagePath?: string;
	lastMessage?: boolean;
	langCode: string;
	channel?: string;
	timeStamp?: string;
}
class ErrorBoundary extends React.Component<Props> {
	state = {
		error: false,
	};
	componentDidCatch(err) {
		console.log('+---------Error Boundary-------+ ', new Date());
		console.log(err);
		this.setState({
			error: true,
		});
	}
	render() {
		return (
			<>
				{!this.state.error ? (
					this.props.children
				) : this.props.silent ? null : (
					<div
						className='msg-wrapper msg-server-wrapper'
						style={{
							marginTop: this.props.botImageCheck ? '22px' : '22px',
							marginBottom: this.props.lastMessage ? '' : '52px',
						}}
						key={Date.now()}
					>
						<div className='msg-server-outer '>
							{this.props.botImageCheck ? (
								<div className={'preview-image-holder'}>
									<img
										src={returnSaneURL(this.props.logoImagePath)}
										alt={TString({
											labelName: 'botAvatarLabel',
											langCode: this.props.langCode,
											fromClass: true,
										})}
									/>
								</div>
							) : null}
							{this.props.channel === 'whatsapp' ? (
								<div className='sf-whatsapp-title-time'>
									<div
										className='sf-whatsapp-title body-text-1'
										dangerouslySetInnerHTML={{
											__html: 'Uh oh! Unfortunately we hit an error',
										}}
									/>
									<p className='whatsApp-time'>{this.props.timeStamp}</p>
								</div>
							) : (
								<div className={'msg-server '}>
									Uh oh! Unfortunately we hit an error
								</div>
							)}
						</div>
					</div>
				)}
			</>
		);
	}
}
export default ErrorBoundary;
